import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[autofocus]'
})
export class InputAutoFocusDirective {
  constructor(private host: ElementRef) {}

  ngAfterViewInit() {
    this.host.nativeElement.focus();
    (this.host.nativeElement as HTMLInputElement).scrollTo({behavior: 'smooth'})
  }
}
